// =============================================================================
// LOADING PAGE COMPONENT
// =============================================================================
// Loading state component for pages loading data

import React from 'react';

interface LoadingPageProps {
  message?: string;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({ 
  message = 'Loading...' 
}) => {
  return (
    <div className="loading-page" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
    }}>
      <div className="loading-spinner" style={{
        width: '48px',
        height: '48px',
        border: '4px solid #f3f4f6',
        borderTop: '4px solid #0ea5e9',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '1rem',
      }} />
      <p style={{
        color: '#6b7280',
        fontSize: '1rem',
        textAlign: 'center',
      }}>
        {message}
      </p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

interface ErrorPageProps {
  error: Error;
  onRetry?: () => void;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ error, onRetry }) => {
  return (
    <div className="error-page" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
    }}>
      <div style={{
        maxWidth: '500px',
        textAlign: 'center',
      }}>
        <h1 style={{
          fontSize: '3rem',
          marginBottom: '1rem',
        }}>
          ⚠️
        </h1>
        <h2 style={{
          fontSize: '1.5rem',
          fontWeight: 600,
          color: '#111827',
          marginBottom: '1rem',
        }}>
          Oops! Something went wrong
        </h2>
        <p style={{
          color: '#6b7280',
          marginBottom: '2rem',
        }}>
          {error.message}
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#0ea5e9',
              color: 'white',
              border: 'none',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#0284c7'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0ea5e9'}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

